import { combineReducers } from 'redux';
import activeUserReducer from './activeUserReducer';

export default combineReducers({
    activeUser : activeUserReducer,
})